import { render, staticRenderFns } from "./Dszc.vue?vue&type=template&id=0deaaa38&scoped=true"
import script from "./Dszc.vue?vue&type=script&lang=js"
export * from "./Dszc.vue?vue&type=script&lang=js"
import style0 from "./Dszc.vue?vue&type=style&index=0&id=0deaaa38&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0deaaa38",
  null
  
)

export default component.exports